import { Box } from "@mui/material";

const PullHandle = () => {
  return (
    <Box
      sx={{
        width: 40,
        height: 4,
        backgroundColor: "grey.300",
        borderRadius: 2,
        position: "absolute",
        top: 8,
        left: "50%",
        transform: "translateX(-50%)",
      }}
    />
  );
};

export default PullHandle;
